var SystemSliderPart = {};
var supportsOrientationChange = ('onorientationchange' in window),
  orientationEvent = supportsOrientationChange ? 'orientationchange' : 'resize';
SystemSliderPart.slider = function () {
  var $systemSliderParts = $('.js-systemparts-slider');
  if ($systemSliderParts.length === 0) {
    return;
  }
  var systemSliderPartCount = $('.systems.systems-part .system-item').length;

  // Flickity Options
  var options = {
    cellAlign: 'center',
    wrapAround: true,
    prevNextButtons: true,
    pageDots: true,
    dragThreshold: 3,
    draggable: true,
    selectedAttraction: 0.01,
    friction: 0.15
  };
  if (matchMedia('screen and (min-width: 576px)').matches) {
    if (systemSliderPartCount >= 3) {
      options = {
        cellAlign: 'center',
        wrapAround: true,
        prevNextButtons: true,
        pageDots: true,
        dragThreshold: 3,
        draggable: false,
        adaptiveHeight: true,
        selectedAttraction: 0.01,
        friction: 0.15
      };
    } else {
      options = {
        cellAlign: 'center',
        wrapAround: false,
        prevNextButtons: true,
        pageDots: true,
        dragThreshold: 3,
        draggable: false,
        adaptiveHeight: true,
        selectedAttraction: 0.01,
        friction: 0.15
      };
    }
  }

  // System Parts Slider - Color Selector
  $systemSliderParts.on('ready.flickity', function () {
    var selectedItem = document.querySelector('.systems.systems-part .system-item.is-selected');
    var scaledImage = selectedItem.getBoundingClientRect().height;
    setTimeout(function () {
      $systemSliderParts.css('visibility', 'visible');
      $systemSliderParts.find('.flickity-viewport').css('min-height', scaledImage + 'px');
    }, 1000);
  });
  $systemSliderParts.off('change.flickity').on('change.flickity', function () {
    window.Product.processChangeColor($systemSliderParts[0].querySelector('.js-product-colors.is-selected'));
  });
  var $sliderPart = $systemSliderParts.flickity(options);
  var flktySystemParts = $sliderPart.data('flickity');
  var $selectedIndex = $systemSliderParts.attr('data-index');
  if ($selectedIndex) {
    $sliderPart.flickity('select', $selectedIndex);
  }
  if (matchMedia('screen and (min-width: 576px)').matches) {
    $sliderPart.on('dragMove.flickity dragEnd.flickity change.flickity', function () {
      $systemSliderParts.flickity('reposition');
      if (flktySystemParts.cells && flktySystemParts.selectedIndex == flktySystemParts.cells.length - 1) {
        $systemSliderParts.addClass('last-cell-selected');
      } else {
        $systemSliderParts.removeClass('last-cell-selected');
      }
    });
    $sliderPart.on('settle.flickity', function () {
      $systemSliderParts.flickity('reposition');
    });
  }
  if ($('.system-slider .systems-part-color').length > 0) {
    $.each($('.system-slider .systems-part-color'), function () {
      var $itemButtonGroup = $(this).find('.color-selector');
      var $itemButtons = $itemButtonGroup.find('li');
      $sliderPart.on('select.flickity', function () {
        $itemButtons.filter('.is-selected').removeClass('is-selected');
        $itemButtons.eq(flktySystemParts.selectedIndex).addClass('is-selected');
      });
      $itemButtonGroup.on('click', 'li', function () {
        var index = $(this).index();
        $sliderPart.flickity('select', index);
      });
    });
  }
  if ($systemSliderParts.length > 0) {
    window.addEventListener(orientationEvent, function () {
      $systemSliderParts.on('select.flickity', function () {
        var selectedItem = document.querySelector('.systems.systems-part .system-item.is-selected');
        if (selectedItem) {
          var scaledImage = selectedItem.getBoundingClientRect().height;
        }
        setTimeout(function () {
          $systemSliderParts.css('visibility', 'visible');
          $systemSliderParts.find('.flickity-viewport').css('min-height', scaledImage + 'px');
        }, 1000);
      });
    }, false);
  }

  //end

  $(window).on('load', function () {
    $systemSliderParts.flickity('resize');
  });
};
SystemSliderPart.slider();
window.SystemSliderPart = SystemSliderPart;


// WEBPACK FOOTER //
// ./scripts/components/sliders/system-slider-part.js